import React from 'react';
import {
  FormikRadioInput as Radio,
  DietSpontaneousActivityLevelType,
} from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';

export const ActivityLevel: React.FC = () => {
  const { t } = useTranslator();

  return (
    <>
      <h2 className="mb-m title-large semi-bold">
        {t('app.goalSettings.spontaneousActivityLevel.headline')}
      </h2>
      <p className="text-text-variant-color mb-xl">
        {t('app.goalSettings.spontaneousActivityLevel.description')}
      </p>

      <Radio
        name="spontaneousActivityLevel"
        value={DietSpontaneousActivityLevelType.SPONTANEOUS_ACTIVITY_LEVEL_NONE}
      >
        <strong>{t('app.goalSettings.spontaneousActivityLevel.optionLowActive.title')}</strong>
        <p className="mb-0">
          {t('app.goalSettings.spontaneousActivityLevel.optionLowActive.description')}
        </p>
      </Radio>

      <Radio
        name="spontaneousActivityLevel"
        value={DietSpontaneousActivityLevelType.SPONTANEOUS_ACTIVITY_LEVEL_LOW}
      >
        <strong>{t('app.goalSettings.spontaneousActivityLevel.optionLightlyActive.title')}</strong>
        <p className="mb-0">
          {t('app.goalSettings.spontaneousActivityLevel.optionLightlyActive.description')}
        </p>
      </Radio>

      <Radio
        name="spontaneousActivityLevel"
        value={DietSpontaneousActivityLevelType.SPONTANEOUS_ACTIVITY_LEVEL_MEDIUM}
      >
        <strong>{t('app.goalSettings.spontaneousActivityLevel.optionMediumActive.title')}</strong>
        <p className="mb-0">
          {t('app.goalSettings.spontaneousActivityLevel.optionMediumActive.description')}
        </p>
      </Radio>

      <Radio
        name="spontaneousActivityLevel"
        value={DietSpontaneousActivityLevelType.SPONTANEOUS_ACTIVITY_LEVEL_HIGH}
      >
        <strong>{t('app.goalSettings.spontaneousActivityLevel.optionVeryActive.title')}</strong>
        <p className="mb-0">
          {t('app.goalSettings.spontaneousActivityLevel.optionVeryActive.description')}
        </p>
      </Radio>
    </>
  );
};

export default ActivityLevel;
